const ContentArchive = () => import('./Main')

const route = {
  path: '/archive/:cateId/:id',
  name: 'archive-content',
  component: ContentArchive
}

export default route
